import React from 'react'; 
import './SessionTimeoutModal.css';

const SessionTimeoutModal = ({ onClose, userRole }) => {
  const message = userRole === "recruiter" 
    ? "Your session as a Talent Acquisition user has expired. Please log in again to continue."
    : "Your session as an applicant has expired. Please log in again to continue.";

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Session Expired</h2>
        <p>{message}</p>
        <button 
          className="modal-button"
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default SessionTimeoutModal;